export const SET_PROJECTINFO = 'SET_PROJECTINFO'
